<script setup>
import { defineAsyncComponent } from 'vue'
import { normalizeRouteSlugParam, toCmsUri } from '@/utils/cms-route-uri'

definePageMeta({
  middleware: 'page-section-handle',
  currentSection: 'pages'
})

const props = defineProps({
  navigation: {
    type: [Array, Object],
    required: false,
    default: () => []
  },
  footer: {
    type: Object,
    required: false,
    default: () => ({})
  },
  banner: {
    type: Object,
    required: false,
    default: () => ({})
  }
})

const route = useRoute()
const sectionHandleMap = useState('page-section-handle', () => ({}))

const slug = computed(() => {
  return normalizeRouteSlugParam(route.params.slug)
})

const cmsUri = computed(() => {
  return toCmsUri(slug.value)
})

const cacheKey = computed(() => `delightAi_en_US:${cmsUri.value}`)
const hasSectionHandle = computed(() =>
  Object.prototype.hasOwnProperty.call(sectionHandleMap.value, cacheKey.value)
)
const sectionHandle = computed(() =>
  hasSectionHandle.value ? sectionHandleMap.value[cacheKey.value] : null
)

// Cache async components to avoid recreating them
const componentCache = {
  pageDefault: null,
  seasonsEvents: null
}

const resolvedComponent = computed(() => {
  if (sectionHandle.value === 'seasonsEvents') {
    if (!componentCache.seasonsEvents) {
      componentCache.seasonsEvents = defineAsyncComponent(() => import('~/components/pages/SeasonsEventsSinglePage/index.vue'))
    }
    return componentCache.seasonsEvents
  }
  
  if (!componentCache.pageDefault) {
    componentCache.pageDefault = defineAsyncComponent(() => import('~/components/pages/PageDefault/index.vue'))
  }
  return componentCache.pageDefault
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
  <component
    v-if="hasSectionHandle"
    :is="resolvedComponent"
    :navigation="props.navigation"
    :footer="props.footer"
    :banner="props.banner"
    siteHandle="delightAi_en_US"
  />
</template>